import { getYear, isValid, parseISO, startOfDay } from "date-fns";
import {
	ClientPortfolioDomainEnum,
	type LoanDetailDataDTO,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { CalculatorPrefill } from "web_myplann/Utils/WebViewModel";

const isPositiveNumber = (value: unknown): value is number =>
	typeof value === "number" && Number.isFinite(value) && value > 0;

export const buildRefinancingPrefill = (
	portfolio: PortfolioDetailResponseDTO,
): CalculatorPrefill | null => {
	if (portfolio.domain !== ClientPortfolioDomainEnum.Loans) {
		return null;
	}
	const data = portfolio.data as LoanDetailDataDTO | null | undefined;

	const installment = data?.installment;
	const interestRate = data?.interestRate;
	const maturityMonths = portfolio.maturityLengthMonths;
	const signedAt = portfolio.signedAt ? parseISO(portfolio.signedAt) : null;

	const prefill: CalculatorPrefill = {
		contractId: portfolio.id,
		contractNumber: portfolio.contractNumber ?? undefined,
		producer: portfolio.producer ?? undefined,
	};

	if (isPositiveNumber(installment)) {
		prefill.originMonthlyPayment = installment;
	}

	if (isPositiveNumber(interestRate)) {
		prefill.originInterest = interestRate;
	}

	if (isPositiveNumber(maturityMonths)) {
		const originMortgageYears = Math.floor(maturityMonths / 12);
		if (originMortgageYears >= 1) {
			prefill.originMortgageYears = originMortgageYears;
		}
	}

	if (signedAt && isValid(signedAt)) {
		const signedYear = getYear(startOfDay(signedAt));
		prefill.repaymentPeriod = Math.max(
			1,
			new Date().getFullYear() - signedYear,
		);
	}

	return prefill;
};
